import { toast } from "react-toastify";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenLoader, PageTitle } from "components";
import { Company } from "components/Company";
import { usePostCompanyMutation } from "redux/api/companyApi";
import { useGetAllProvincesQuery } from "redux/api/provinceApi";
import { ISelectOption } from "Interfaces/Utils";
import { useIntl } from "react-intl";

// Static vars

const RETURN_PAGE = "/companies";

/**
 * Component to render news creation view
 */

export const CompanyNewPage = () => {
  const { formatMessage } = useIntl();
  const PAGE_TITLE = formatMessage({ id: "company.new" });
  const RETURN_LABEL = formatMessage({ id: "company.back" });
  const CREATION_SUCCESS_LABEL = formatMessage({ id: "company.createdSuccessfuly" });


  const navigate = useNavigate();

  // API calls

  const [ createCompany, { data: postedCompanyData, isSuccess: isPostedCompanySuccess, error: apiError } ] = usePostCompanyMutation();
  const {data: provinces, isLoading: isProvincesLoading} = useGetAllProvincesQuery();


  // UseEffect to manage creation success

  useEffect(() => {
    if (isPostedCompanySuccess && postedCompanyData) {
      toast.success(CREATION_SUCCESS_LABEL);
      navigate(RETURN_PAGE);
    }
  }, [isPostedCompanySuccess, postedCompanyData, navigate]);

  // Fetch managers data
  const provinceSelectOptions: ISelectOption[] = useMemo(() => {
      
    if (!provinces) return [];
    
     return provinces.map((province) => ({
      label: province.name,
      value: province._id,
    }));
  }, [provinces])

  // Function to create news with form results

  const postCompanyHandler = (formData: FormData) => {
    createCompany(formData);
  };

  if (isProvincesLoading) return <FullScreenLoader/>

  return (
    <>
      <PageTitle
        pageTitle={PAGE_TITLE}
        returnPage={RETURN_PAGE}
        returnLabel={RETURN_LABEL}
      />
      <Company.Form
        provinces={provinceSelectOptions}
        onSubmit={postCompanyHandler}
        apiError={apiError}
      />
    </>
  );
};